import React, { Component } from 'react';
import StationService from '../services/station_service';
import DropDownListS from './dropdown';
import { FaEye, FaDownload } from 'react-icons/fa';

const getSerSignatureDefaults = () => {
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const userKey = user.email || user.id || 'default';
  const savedDefaults = JSON.parse(
    localStorage.getItem(`serGenerationSignatureDefaults:${userKey}`) || '{}'
  );

  return {
    serFirstSignature: savedDefaults.serFirstSignature || 'naik',
    serSecondSignature: savedDefaults.serSecondSignature || 'krishna'
  };
};

class StepThree extends Component {
  state = {
    loading: false, // Tracks "Convert All" global status
    error: '',
    success: false,
    imageSuccess: false,
    imageError: '',
    pendingAction: null,
    generatedFilePaths: {},
    draggingStepId: null,
    dragOverStepId: null,
    generationStarted: false,
    selectedGenerationVersions: { toc: '', pdf: '', excel: '', rfid: '' },
    tocProgress: 0,
    tocStatusMessage: '',
    tocStatus: 'idle',
    pdfProgress: 0,
    pdfStatusMessage: '',
    pdfStatus: 'idle',
    excelProgress: 0,
    excelStatusMessage: '',
    excelStatus: 'idle',
    excelV2Progress: 0,
    excelV2StatusMessage: '',
    excelV2Status: 'idle',
    // Options Modal State
    showOptionsModal: false,
    activeTab: 'toc', // Default tab set to TOC
    ...getSerSignatureDefaults(),
    serSignatureDefaultsSaved: false,
    stepsStatus: [
      { id: 'pdf', name: "TD PDF", status: "pending" },
      { id: 'pdf_csv', name: "TD Checksum CSV", status: "pending" },
      { id: 'excel', name: "TD Formatted Excel", status: "pending" },
      { id: 'excel_v2', name: "TD V2 Excel", status: "pending" },
      { id: 'rfid', name: "RFID Layout PDF", status: "pending" },
      { id: 'toc', name: "TOC PDF", status: "pending" },
    ]
  };

  componentDidMount() {
    this.initializeGenerationVersion();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.station !== this.props.station) {
      this.setState(prev => ({
        selectedGenerationVersions: { toc: '', pdf: '', excel: '', rfid: '' },
        generationStarted: false,
        loading: false,
        error: '',
        success: false,
        generatedFilePaths: {},
        stepsStatus: prev.stepsStatus.map(step => ({ ...step, status: 'pending', errorMessage: '' }))
      }), () => {
        if (!this.props.versionsLoading) this.initializeGenerationVersion();
      });
      return;
    }

    if (
      (prevProps.versionsLoading && !this.props.versionsLoading) ||
      prevProps.versionsError !== this.props.versionsError
    ) {
      this.initializeGenerationVersion();
    }
  }

  initializeGenerationVersion = () => {
    const { availableVersions = [], versionsLoading, versionsError } = this.props;
    let initialVersion = '';

    if (!versionsLoading && !versionsError) {
      if (availableVersions.length === 0) {
        initialVersion = '2.0.0';
      } else {
        const versionsByCreation = availableVersions
          .filter(item => typeof item.version === 'string' && item.version.trim())
          .map(item => ({ version: item.version, createdAt: Date.parse(item.created_at) }))
          .filter(item => Number.isFinite(item.createdAt))
          .sort((first, second) => second.createdAt - first.createdAt);
        initialVersion = versionsByCreation[0]?.version
          || availableVersions.find(item => typeof item.version === 'string' && item.version.trim())?.version
          || '';
      }
    }

    const selectedGenerationVersions = {
      toc: initialVersion,
      pdf: initialVersion,
      excel: initialVersion,
      rfid: initialVersion
    };
    this.setState({ selectedGenerationVersions });
    this.props.onGenerationVersionChange?.(selectedGenerationVersions);
  };

  handleGenerationVersionChange = (versionKey, version) => {
    this.setState(prev => ({
      selectedGenerationVersions: {
        ...prev.selectedGenerationVersions,
        [versionKey]: version
      }
    }), () => this.props.onGenerationVersionChange?.(this.state.selectedGenerationVersions));
  };

  getGenerationVersionError = (stepId = null) => {
    if (this.props.versionsLoading) return 'Station versions are still loading.';
    if (this.props.versionsError) return this.props.versionsError;
    const versionKeys = stepId
      ? [stepId === 'pdf_csv' || stepId === 'excel_v2' ? (stepId === 'pdf_csv' ? 'pdf' : 'excel') : stepId]
      : ['toc', 'pdf', 'excel', 'rfid'];
    const missingVersions = versionKeys.filter(key => !this.state.selectedGenerationVersions[key]);
    if (missingVersions.length > 0) {
      return `Select a version for ${missingVersions.join(', ')} before generating.`;
    }
    return '';
  };

  // Zone list options
  zoneList = [
    { value: 'SER', label: 'SER (SOUTH EASTERN RAILWAY)' },
    { value: 'SR', label: 'SR (SOUTHERN RAILWAY)' },
    { value: 'EDFC', label: 'EDFC (DFCCIL)' },
    { value: 'WR', label: 'WR (WESTERN RAILWAY)' }
  ];

  // Available signatures for TOC customization
  signatureOptions = [
    { value: 'kumar', label: 'V.P.S KUMAR' },
    { value: 'krishna', label: 'D. KRISHNA SAI' },
    { value: 'phani', label: 'T.V.L.N.P. PHANI KUMAR' },
    { value: 'jitendra', label: 'S JITENDRA VIJAY' },
    { value: 'murali', label: 'MURALI' },
    { value: 'durga', label: 'S NAGA DURGA' },
    { value: 'naik', label: 'NAIK' },
    { value: 'sai', label: 'SAI' },
    { value: 'varma', label: 'S.G. VARMA' },
    { value: 'rajitha', label: 'CH.RAJITHA' }
  ];

  saveSerSignatureDefaults = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userKey = user.email || user.id || 'default';
    const { serFirstSignature, serSecondSignature } = this.state;

    localStorage.setItem(
      `serGenerationSignatureDefaults:${userKey}`,
      JSON.stringify({ serFirstSignature, serSecondSignature })
    );
    this.setState({ serSignatureDefaultsSaved: true });
  };

  getMimeType = (filename) => {
    const ext = filename.split('.').pop().toLowerCase();
    const mimeMap = {
      pdf: 'application/pdf',
      png: 'image/png',
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      gif: 'image/gif',
      bmp: 'image/bmp',
      txt: 'text/plain',
      csv: 'text/csv',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    };
    return mimeMap[ext] || 'application/octet-stream';
  };

  updateStepStatus = (stepId, status, errorMessage = '') => {
    this.setState(prev => {
      const steps = prev.stepsStatus.map(step =>
        step.id === stepId ? { ...step, status, errorMessage } : step
      );
      return { stepsStatus: steps };
    });
  };

  openFile = async (folderType, station, filename) => {
    const { outputPath } = this.props;
    const filePath = `${outputPath}/${folderType}/${station}/v${this.props.selectedVersion}/${filename}`.replace(/\\/g, '/');

    try {
      const res = await StationService.openFile(
        { file_path: filePath, station: station },
        { responseType: 'blob' }
      );

      const mimeType = this.getMimeType(filename);
      const blob = new Blob([res.data], { type: mimeType });
      const url = URL.createObjectURL(blob);

      const viewable = ["pdf", "png", "jpg", "jpeg", "gif", "bmp", "txt", "csv", "xlsx"];

      if (viewable.includes(filename.split('.').pop().toLowerCase())) {
        window.open(url, "_blank");
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      }

      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (err) {
      console.error("Error opening file:", err);
      alert("Error opening file.");
    }
  };

  triggerGeneratedStepAction = async (step, mode = 'view', filePathKey = step?.id) => {
    if (!step) return;

    const actionKey = filePathKey === step.id
      ? `${step.id}_${mode}`
      : `${filePathKey}_${mode}`;
    this.setState({ pendingAction: actionKey });

    try {
      const filePath = this.state.generatedFilePaths[filePathKey];
      if (!filePath) {
        throw new Error('The generated file path was not returned by the server.');
      }

      const res = await StationService.openFile(
        { file_path: filePath, station: this.props.station },
        { responseType: 'blob' }
      );

      const filename = filePath.replace(/\\/g, '/').split('/').pop();
      const mimeType = this.getMimeType(filename);
      const blob = new Blob([res.data], { type: mimeType });
      const url = URL.createObjectURL(blob);
      const viewable = ["pdf", "png", "jpg", "jpeg", "gif", "bmp", "txt", "csv", "xlsx"];

      if (mode === 'view' && viewable.includes(filename.split('.').pop().toLowerCase())) {
        window.open(url, "_blank");
      } else {
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      }

      setTimeout(() => URL.revokeObjectURL(url), 10000);
    } catch (err) {
      console.error(`Error ${mode}ing file:`, err);
      alert(`Error ${mode}ing file.`);
    } finally {
      this.setState({ pendingAction: null });
    }
  };

  moveGenerationStep = (stepId, direction) => {
    if (this.state.generationStarted || this.state.loading) return;

    this.setState(prev => {
      const generationSteps = [...prev.stepsStatus];
      const currentIndex = generationSteps.findIndex(step => step.id === stepId);
      const targetIndex = currentIndex + direction;
      if (currentIndex < 0 || targetIndex < 0 || targetIndex >= generationSteps.length) return null;

      [generationSteps[currentIndex], generationSteps[targetIndex]] = [
        generationSteps[targetIndex], generationSteps[currentIndex]
      ];

      return {
        stepsStatus: generationSteps
      };
    });
  };

  handleStepDragStart = (event, stepId) => {
    if (this.state.generationStarted || this.state.loading) {
      event.preventDefault();
      return;
    }

    event.dataTransfer.effectAllowed = 'move';
    event.dataTransfer.setData('text/plain', stepId);

    const dragPreview = event.currentTarget.cloneNode(true);
    Object.assign(dragPreview.style, {
      position: 'fixed',
      top: '-1000px',
      left: '-1000px',
      width: `${event.currentTarget.getBoundingClientRect().width}px`,
      background: '#ffffff',
      border: '1px solid #b8c7d8',
      borderRadius: '6px',
      boxShadow: '0 8px 20px rgba(25, 62, 108, 0.18)',
      opacity: '1',
      transform: 'scale(0.98)',
      pointerEvents: 'none'
    });
    document.body.appendChild(dragPreview);
    event.dataTransfer.setDragImage(dragPreview, 24, 20);
    window.setTimeout(() => dragPreview.remove(), 0);

    this.setState({ draggingStepId: stepId, dragOverStepId: null });
  };

  handleStepDragOver = (event, stepId) => {
    if (this.state.generationStarted || !this.state.draggingStepId) return;
    event.preventDefault();
    event.dataTransfer.dropEffect = 'move';
    if (this.state.dragOverStepId !== stepId) this.setState({ dragOverStepId: stepId });
  };

  handleStepDrop = (event, targetStepId) => {
    event.preventDefault();
    const sourceStepId = event.dataTransfer.getData('text/plain') || this.state.draggingStepId;
    const previousPositions = new Map(
      Array.from(this.stepsContainerRef?.querySelectorAll('[data-step-id]') || [])
        .map(row => [row.dataset.stepId, row.getBoundingClientRect().top])
    );

    this.setState(prev => {
      const generationSteps = [...prev.stepsStatus];
      const sourceIndex = generationSteps.findIndex(step => step.id === sourceStepId);
      const targetIndex = generationSteps.findIndex(step => step.id === targetStepId);
      if (sourceIndex < 0 || targetIndex < 0) {
        return { draggingStepId: null, dragOverStepId: null };
      }

      const [draggedStep] = generationSteps.splice(sourceIndex, 1);
      generationSteps.splice(targetIndex, 0, draggedStep);
      return {
        stepsStatus: generationSteps,
        draggingStepId: null,
        dragOverStepId: null
      };
    }, () => this.animateStepReorder(previousPositions));
  };

  animateStepReorder = (previousPositions) => {
    const rows = this.stepsContainerRef?.querySelectorAll('[data-step-id]') || [];

    rows.forEach(row => {
      const previousTop = previousPositions.get(row.dataset.stepId);
      if (previousTop === undefined) return;

      const offset = previousTop - row.getBoundingClientRect().top;
      if (!offset) return;

      row.style.transition = 'none';
      row.style.transform = `translateY(${offset}px)`;
      row.style.position = 'relative';
      row.style.zIndex = '1';

      window.requestAnimationFrame(() => {
        row.style.transition = 'transform 240ms cubic-bezier(0.2, 0.75, 0.25, 1)';
        row.style.transform = 'translateY(0)';
      });

      window.setTimeout(() => {
        row.style.transition = '';
        row.style.transform = '';
        row.style.position = '';
        row.style.zIndex = '';
      }, 270);
    });
  };

  handleStepDragEnd = () => {
    this.setState({ draggingStepId: null, dragOverStepId: null });
  };

  handleStepReorderKeyDown = (event, stepId) => {
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
      event.preventDefault();
      this.moveGenerationStep(stepId, event.key === 'ArrowUp' ? -1 : 1);
    }
  };

  handleRegenerateStep = async (stepId) => {
    const versionError = this.getGenerationVersionError(stepId);
    if (versionError) {
      this.setState({ error: versionError });
      return;
    }

    this.props.onGenerationStateChange?.(true);
    await this.processSingleStep(stepId);
    this.setState(prev => {
      const hasError = prev.stepsStatus.some(step => step.status === 'error');
      return {
        success: hasError,
        error: hasError ? 'Some files failed to process' : ''
      };
    }, () => {
      const hasError = this.state.stepsStatus.some(step => step.status === 'error');
      this.props.onGenerationStateChange?.(false);
    });
  };

  handleDownloadGeneratedZip = async () => {
    try {
      await this.props.onDownloadGeneratedZip?.();
    } catch (err) {
      console.error('Error downloading generated files ZIP:', err);
      alert('Error downloading ZIP.');
    }
  };

  /**
   * Execute single conversion step by index
   */
  processSingleStep = async (stepId) => {
    const { inputPath, station, stationZone, format } = this.props;
    const outputZone = stationZone || format;
    const { serFirstSignature, serSecondSignature, selectedGenerationVersions } = this.state;
    const isPdfOutput = stepId === 'pdf' || stepId === 'pdf_csv';
    const operationStepId = stepId === 'pdf_csv' ? 'pdf' : stepId;
    let generatedFilePath = '';
    let generatedCsvFilePath = '';
    this.setState(prev => ({
      generatedFilePaths: {
        ...prev.generatedFilePaths,
        ...(isPdfOutput ? { pdf: '', pdf_csv: '' } : { [stepId]: '' })
      },
      stepsStatus: prev.stepsStatus.map(step => {
        // While generating PDF, show loading ONLY for TD PDF.
        // Keep TD Checksum CSV waiting until PDF generation completes.
        if (operationStepId === 'pdf') {
          if (step.id === 'pdf') {
            return {
              ...step,
              status: 'loading',
              errorMessage: ''
            };
          }

          if (step.id === 'pdf_csv') {
            return {
              ...step,
              status: 'pending',
              errorMessage: ''
            };
          }

          return step;
        }

        if (step.id === stepId) {
          return {
            ...step,
            status: 'loading',
            errorMessage: ''
          };
        }

        return step;
      })
    }));

    try {
      switch (operationStepId) {
        case 'toc': // TOC PDF
          this.setState({ tocProgress: 0, tocStatusMessage: 'Starting TOC PDF generation', tocStatus: 'progress' });
          await StationService.generateTocPdfProgress({
            input_path: `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TOC_${station}.xlsx`,
            output_path: `${inputPath}/Converted_Documents/${station}`,
            station_info_path: `${inputPath}/Input_Documents/${station}/VERSION_IN_BACKEND/Station_Info_${station}.xlsx`,
            station_name: station,
            version: selectedGenerationVersions.toc,
            ser_first_signature: outputZone === 'SER' ? serFirstSignature : '',
            ser_second_signature: outputZone === 'SER' ? serSecondSignature : ''
          }, (event) => {
            generatedFilePath = event?.file_path || generatedFilePath;
            const progress = Number(event?.progress ?? 0);
            const message = event?.message || '';
            const status = event?.status || 'progress';

            this.setState({
              tocProgress: progress,
              tocStatusMessage: message || this.state.tocStatusMessage,
              tocStatus: status
            });

            if (status === 'error') {
              throw new Error(event.error || 'TOC PDF generation failed');
            }

            if (status === 'complete') {
              this.setState({
                tocProgress: 100,
                tocStatusMessage: event.message || 'TOC PDF generated',
                tocStatus: 'complete'
              });
            }
          });
          break;

        case 'excel': // TD Formatted Excel
          this.setState({ excelProgress: 0, excelStatusMessage: 'Starting tag data Excel generation', excelStatus: 'progress' });
          await StationService.convertFileProgress({
            input_path: `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TD_${station}.xlsx`,
            output_path: `${inputPath}/Converted_Documents/${station}`,
            station_info_path: `${inputPath}/Input_Documents/${station}/VERSION_IN_BACKEND/Station_Info_${station}.xlsx`,
            station_name: station,
            version: selectedGenerationVersions.excel
          }, (event) => {
            generatedFilePath = event?.file_path || generatedFilePath;
            const progress = Number(event?.progress ?? 0);
            const message = event?.message || '';
            const status = event?.status || 'progress';

            this.setState({
              excelProgress: progress,
              excelStatusMessage: message || this.state.excelStatusMessage,
              excelStatus: status
            });

            if (status === 'error') {
              throw new Error(event.error || 'Excel generation failed');
            }

            if (status === 'complete') {
              this.setState({
                excelProgress: 100,
                excelStatusMessage: event.message || 'Excel generated',
                excelStatus: 'complete'
              });
            }
          });
          break;

        case 'excel_v2': // TD V2 Excel
          this.setState({
            excelV2Progress: 0,
            excelV2StatusMessage: 'Starting tag data V2 Excel generation',
            excelV2Status: 'progress'
          });
          {
            const response = await StationService.convertFileV2({
              input_path: `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TD_${station}.xlsx`,
              output_path: `${inputPath}/Converted_Documents/${station}/VERSION_IN_BACKEND`,
              version: selectedGenerationVersions.excel
            });
            generatedFilePath = response.data?.output_file || '';
            this.setState({
              excelV2Progress: 100,
              excelV2StatusMessage: response.data?.message || 'V2 Excel generated',
              excelV2Status: 'complete'
            });
          }
          break;

        case 'pdf': // TD PDF
          this.setState({ pdfProgress: 0, pdfStatusMessage: 'Starting tag data PDF generation', pdfStatus: 'progress' });
          await StationService.generatePdfProgress({
            input_path: `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TD_${station}.xlsx`,
            output_path: `${inputPath}/Converted_Documents/${station}`,
            station_info_path: `${inputPath}/Input_Documents/${station}/VERSION_IN_BACKEND/Station_Info_${station}.xlsx`,
            station_name: station,
            version: selectedGenerationVersions.pdf
          }, (event) => {
            generatedFilePath = event?.file_path || generatedFilePath;
            generatedCsvFilePath = event?.csv_file_path || generatedCsvFilePath;
            const progress = Number(event?.progress ?? 0);
            const message = event?.message || '';
            const status = event?.status || 'progress';

            this.setState({
              pdfProgress: progress,
              pdfStatusMessage: message || this.state.pdfStatusMessage,
              pdfStatus: status
            });

            if (status === 'error') {
              throw new Error(event.error || 'TD PDF generation failed');
            }

            if (status === 'complete') {
              this.setState({
                pdfProgress: 100,
                pdfStatusMessage: event.message || 'TD PDF generated',
                pdfStatus: 'complete'
              });
            }
          });
          break;

        case 'rfid': // RFID Layout PDF
          const response = await StationService.generatePdfFromImage({
            image_path: `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/schematic_plan/RFID_TIN_layout.png`,
            output_path: `${inputPath}/Converted_Documents/${station}`,
            tag_data_path: `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TD_${station}.xlsx`,
            station_info_path: `${inputPath}/Input_Documents/${station}/VERSION_IN_BACKEND/Station_Info_${station}.xlsx`,
            station_name: station,
            version: selectedGenerationVersions.rfid
          });
          generatedFilePath = response.data?.file_path || '';
          break;

        // case 'inputs':
        //   await StationService.copyFilesToOutput({
        //     station: station,
        //     file_paths: [
        //       `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/RCT_${station}.xlsx`,
        //       `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TD_${station}.xlsx`,
        //       `${inputPath}/Output_Documents/${station}/VERSION_IN_BACKEND/tables/TOC_${station}.xlsx`,
        //     ],
        //     output_path: `${inputPath}/Converted_Documents/${station}/VERSION_IN_BACKEND`
        //   });
        //   break;

        default:
          throw new Error("Invalid step id");
      }

      if (!generatedFilePath) {
        throw new Error('The generated file path was not returned by the server.');
      }
      if (isPdfOutput && !generatedCsvFilePath) {
        throw new Error('The TD checksum CSV path was not returned by the server.');
      }

      this.setState(prev => ({
        generatedFilePaths: {
          ...prev.generatedFilePaths,
          ...(isPdfOutput
            ? { pdf: generatedFilePath, pdf_csv: generatedCsvFilePath }
            : { [stepId]: generatedFilePath })
        },
        stepsStatus: prev.stepsStatus.map(step =>
          isPdfOutput && (step.id === 'pdf' || step.id === 'pdf_csv') || step.id === stepId
            ? { ...step, status: 'completed', errorMessage: '' }
            : step
        )
      }));
      return true;
    } catch (err) {
      console.error(`Step ${stepId} failed:`, err);
      const responseError = err.response?.data?.message
        || err.response?.data?.error
        || err.response?.data?.detail;
      const errorMessage = typeof responseError === 'string'
        ? responseError
        : responseError
          ? JSON.stringify(responseError)
          : err.message || 'Generation failed';
      this.setState(prev => ({
        stepsStatus: prev.stepsStatus.map(step =>
          isPdfOutput && (step.id === 'pdf' || step.id === 'pdf_csv')
            ? {
              ...step,
              status: 'error',
              errorMessage
            }
            : step.id === stepId
              ? {
                ...step,
                status: 'error',
                errorMessage
              }
              : step
        )
      }));
      return false;
    }
  };

  // Handler when "Convert All" is clicked
  handleConvertAllClick = () => {
    const { format, stationZone } = this.props;
    const outputZone = stationZone || format;
    const versionError = this.getGenerationVersionError();
    if (versionError) {
      this.setState({ error: versionError });
      return;
    }

    // Show modal ONLY if SER is selected
    if (outputZone === 'SER') {
      this.setState({ showOptionsModal: true, activeTab: 'toc' });
    } else {
      // Direct bulk conversion for other zones
      this.handleStartBulkConversion();
    }
  };

  // Close Options Modal
  handleCloseOptionsModal = () => {
    this.setState({ showOptionsModal: false });
  };

  // Execute All Conversions sequentially
  handleStartBulkConversion = async () => {
    const { inputPath, station, onGenerationStateChange } = this.props;
    const versionError = this.getGenerationVersionError();
    if (versionError) {
      this.setState({ error: versionError });
      return;
    }

    onGenerationStateChange?.(true);

    this.setState({
      showOptionsModal: false,
      loading: true,
      generationStarted: true,
      error: '',
      success: false,
      generatedFilePaths: {},
      stepsStatus: this.state.stepsStatus.map(s => ({ ...s, status: "pending", errorMessage: '' }))
    });

    try {
      await StationService.deleteFilesInOutput({
        station: station,
        output_path: `${inputPath}/Converted_Documents/${station}/VERSION_IN_BACKEND`
      });
    } catch (err) {
      console.error("Delete failed:", err);
    }

    let hasError = false;
    const generationOrder = this.state.stepsStatus.map(step => step.id);
    const processedSteps = new Set();

    for (const stepId of generationOrder) {
      if (processedSteps.has(stepId)) continue;
      const stepSuccess = await this.processSingleStep(stepId);
      if (stepId === 'pdf' || stepId === 'pdf_csv') {
        processedSteps.add('pdf');
        processedSteps.add('pdf_csv');
      } else {
        processedSteps.add(stepId);
      }
      if (!stepSuccess) {
        hasError = true;
      }
    }

    this.setState({
      loading: false,
      success: hasError,
      error: hasError ? "Some files failed to process" : ""
    }, () => {
      onGenerationStateChange?.(false);
    });
  };

  handleDismissPopup = () => {
    this.setState({ success: false, imageSuccess: false });
  };

  handleClosePopup = () => {
    if (this.props.onCloseGenerationModal) {
      this.props.onCloseGenerationModal(true);
      return;
    }

    window.location.reload();
  };

  renderStepActions = (step) => {
    const { pendingAction, generatedFilePaths } = this.state;

    if (step.status === 'error') {
      return (
        <button
          type="button"
          className="btn btn-sm"
          disabled={this.state.stepsStatus.some(item => item.status === 'loading')}
          onClick={() => this.handleRegenerateStep(step.id)}
          style={{
            borderRadius: '5px',
            padding: '3px 9px',
            fontSize: '0.7rem',
            fontWeight: 500,
            border: '1px solid #fecaca',
            backgroundColor: '#fef2f2',
            color: '#b91c1c'
          }}
        >
          Regenerate
        </button>
      );
    }

    const files = [{ key: step.id }];

    return (
      <div className="d-flex align-items-center justify-content-end" style={{ gap: '4px', width: '100%' }}>
        {files.map(file => (
          <div key={file.key} className="d-flex align-items-center justify-content-end" style={{ gap: '6px', minHeight: '28px' }}>
            <div className="d-flex align-items-center justify-content-end" style={{ gap: '4px' }}>
              {['view', 'download'].map(mode => {
                const actionKey = file.key === step.id ? `${step.id}_${mode}` : `${file.key}_${mode}`;
                const fileGenerated = step.status === 'completed' && Boolean(generatedFilePaths[file.key]);
                return (
                  <button
                    key={actionKey}
                    type="button"
                    className="btn btn-sm d-flex align-items-center"
                    disabled={!fileGenerated || pendingAction !== null}
                    onClick={() => this.triggerGeneratedStepAction(step, mode, file.key)}
                    style={{
                      borderRadius: '5px',
                      padding: '3px 8px',
                      fontSize: '0.675rem',
                      fontWeight: 500,
                      lineHeight: 1.35,
                      border: mode === 'view' ? '1px solid #3489f2' : '1px solid #12b94c',
                      backgroundColor: mode === 'view' ? '#eff6ff' : '#f0fdf4',
                      color: mode === 'view' ? '#1d4ed8' : '#15803d',
                      whiteSpace: 'nowrap',
                      gap: '4px'
                    }}
                  >
                    {mode === 'view' ? (
                      <>
                        <FaEye size={11} />
                        {pendingAction === actionKey ? 'Opening...' : 'View'}
                      </>
                    ) : (
                      <>
                        <FaDownload size={11} />
                        {pendingAction === actionKey ? 'Downloading...' : 'Download'}
                      </>
                    )}
                  </button>);
              })}
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderStepProgress = (step) => {
    const {
      tocProgress, tocStatusMessage,
      excelProgress, excelStatusMessage,
      excelV2Progress, excelV2StatusMessage,
      pdfProgress, pdfStatusMessage
    } = this.state;

    if (step.status !== 'loading') {
      const statusLabel = step.status === 'completed' ? 'Completed' : step.status === 'error' ? 'Failed' : 'Waiting';
      const statusColor = step.status === 'completed' ? '#15803d' : step.status === 'error' ? '#b91c1c' : '#64748b';
      return <span style={{ color: statusColor, fontSize: '0.75rem', fontWeight: 600 }}>{statusLabel}</span>;
    }

    const progressDetails = {
      toc: { message: tocStatusMessage || 'Generating TOC PDF...', progress: tocProgress },
      excel: { message: excelStatusMessage || 'Generating TD Formatted Excel...', progress: excelProgress },
      excel_v2: { message: excelV2StatusMessage || 'Generating TD V2 Excel...', progress: excelV2Progress },
      pdf: { message: pdfStatusMessage || 'Generating TD PDF and checksum CSV...', progress: pdfProgress },
      pdf_csv: { message: 'Generating TD Checksum CSV...', progress: pdfProgress },
      rfid: { message: 'Generating RFID Layout PDF...', progress: null }
    }[step.id];
    const progress = progressDetails?.progress;

    return (
      <div style={{ width: '100%', maxWidth: '260px', minWidth: '120px', textAlign: 'center' }}>
        <div className="d-flex justify-content-center align-items-center gap-2 mb-1" style={{ color: '#b45309', fontSize: '0.7rem', fontWeight: 500 }}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{progressDetails?.message}</span>
          {progress !== null && <span style={{ flexShrink: 0, fontVariantNumeric: 'tabular-nums' }}>{progress || 0}%</span>}
        </div>
        <div className="progress" style={{ height: '4px', borderRadius: '999px', backgroundColor: '#fef3c7' }}>
          <div
            className="progress-bar progress-bar-striped progress-bar-animated"
            style={{
              width: progress === null ? '100%' : `${progress || 0}%`,
              backgroundColor: '#f59e0b',
              borderRadius: '999px'
            }}
          ></div>
        </div>
      </div>
    );
  };

  render() {
    const { format, stationZone, setFormat, station } = this.props;
    const {
      loading, error, imageError, stepsStatus,
      showOptionsModal, activeTab,
      serFirstSignature, serSecondSignature,
    } = this.state;

    const isAnyLoading = loading || stepsStatus.some(s => s.status === 'loading');
    const availableVersions = this.props.availableVersions || [];
    const versionsLoading = Boolean(this.props.versionsLoading);
    const generationVersionOptions = availableVersions.length === 0
      ? [{ value: '2.0.0', label: '2.0.0' }]
      : availableVersions
        .filter(item => typeof item.version === 'string' && item.version.trim())
        .map(item => ({ value: item.version, label: item.version }));
    const missingVersionKeys = ['toc', 'pdf', 'excel', 'rfid']
      .filter(key => !this.state.selectedGenerationVersions[key]);
    const versionSelectionError = this.props.versionsError || (
      !versionsLoading && missingVersionKeys.length > 0
        ? `Select a version for ${missingVersionKeys.join(', ')} before generating.`
        : ''
    );
    const isGenerationVersionReady = !versionsLoading && !versionSelectionError && missingVersionKeys.length === 0;
    const versionDropdownDisabled = versionsLoading || Boolean(this.props.versionsError) || isAnyLoading || this.state.generationStarted;
    const outputZone = stationZone || format;
    const isButtonDisabled = isAnyLoading || !outputZone || !isGenerationVersionReady;
    const generationVersionLabels = {
      excel: 'TD Excel Formatted',
      pdf: 'TD Pdf version',
      rfid: 'RFID version',
      toc: 'TOC version'
    };
    const completedSteps = stepsStatus.filter(step => step.status === 'completed').length;
    const failedSteps = stepsStatus.filter(step => step.status === 'error').length;
    const isGeneratedZipReady = this.state.generationStarted && !isAnyLoading && completedSteps > 0 && this.props.onDownloadGeneratedZip;
    const progressPercent = (completedSteps / stepsStatus.length) * 100;

    return (
      <div className="container-fluid p-0">
        {/* Zone selector + primary action */}
        <div
          className="d-flex flex-column flex-xl-row align-items-xl-end justify-content-between gap-3 px-3 py-3 mb-3"
          style={{
            backgroundColor: '#ffffff',
            border: '2px solid #cbd5e1',
            borderRadius: '10px',
            boxShadow: '0 1px 3px rgba(15, 23, 42, 0.04)'
          }}
        >
          <div className="flex-grow-1" style={{ minWidth: 0 }}>
            <div className="d-flex flex-wrap align-items-end gap-2">
              {['excel', 'pdf', 'rfid', 'toc'].map(versionKey => (
                <div key={versionKey} style={{ minWidth: '130px', maxWidth: '170px', flex: '1 1 140px' }}>
                  <label
                    className="form-label mb-1"
                    style={{
                      color: '#334155',
                      fontWeight: 600,
                      fontSize: '0.8125rem',
                      textTransform: 'uppercase'
                    }}
                  >
                    {generationVersionLabels[versionKey]}
                  </label>
                  <DropDownListS
                    selectedValue={this.state.selectedGenerationVersions[versionKey]}
                    data={generationVersionOptions}
                    onUpdateSelectedValue={(version) => this.handleGenerationVersionChange(versionKey, version)}
                    placeholder={versionsLoading ? 'Loading...' : 'Select version'}
                    disabled={versionDropdownDisabled}
                    compact
                  />
                </div>
              ))}
              {!stationZone && <div style={{ minWidth: 0, maxWidth: '260px', flex: '1 1 210px' }}>
                <label
                  className="form-label mb-1"
                  style={{
                    color: '#334155',
                    fontWeight: 600,
                    fontSize: '0.8125rem',
                    letterSpacing: '0.01em',
                    textTransform: 'uppercase'
                  }}
                >
                  Output zone
                </label>
                <DropDownListS
                  selectedValue={outputZone}
                  data={this.zoneList}
                  onUpdateSelectedValue={setFormat}
                  placeholder="Select a zone"
                  disabled={isAnyLoading}
                  compact
                />
              </div>}
            </div>
            {versionSelectionError && (
              <div className="small text-danger mt-1" role="alert">
                {versionSelectionError}
              </div>
            )}
          </div>

          <div className="d-flex align-items-center gap-2 flex-shrink-0">
            <button
              onClick={this.handleConvertAllClick}
              className="btn d-inline-flex align-items-center justify-content-center flex-shrink-0"
              disabled={isButtonDisabled}
              style={{
                minHeight: '42px',
                minWidth: '190px',
                backgroundColor: isButtonDisabled ? '#94a3b8' : '#1e3a5f',
                borderColor: isButtonDisabled ? '#94a3b8' : '#1e3a5f',
                color: '#ffffff',
                borderRadius: '8px',
                fontWeight: 600,
                fontSize: '0.875rem',
                letterSpacing: '0.01em',
                boxShadow: isButtonDisabled ? 'none' : '0 1px 2px rgba(30, 58, 95, 0.2)',
                transition: 'background-color 0.15s ease, box-shadow 0.15s ease'
              }}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2" aria-hidden="true"></span>
                  Generating documents...
                </>
              ) : (
                <>
                  <i className="bi bi-play-fill me-2"></i>
                  {outputZone === 'SER' ? 'Review & generate' : 'Start generation'}
                </>
              )}
            </button>
          </div>
        </div>

        {/* Generation progress card */}
        <section
          className="overflow-hidden"
          aria-label="Generation progress"
          style={{
            backgroundColor: '#ffffff',
            border: '2px solid #cbd5e1',
            borderRadius: '10px',
            boxShadow: '0 1px 3px rgba(15, 23, 42, 0.04)'
          }}
        >
          {/* Card header */}
          <div
            className="d-flex flex-wrap align-items-center justify-content-between gap-3 px-3 py-2_5"
            style={{
              backgroundColor: '#f8fafc',
              borderBottom: '2px solid #cbd5e1',
              paddingTop: '12px',
              paddingBottom: '12px'
            }}
          >
            <div className="d-flex flex-wrap align-items-baseline gap-2">
              <h6
                className="mb-0"
                style={{
                  color: '#0f172a',
                  fontWeight: 600,
                  fontSize: '0.9375rem',
                  letterSpacing: '0.04em'
                }}
              >
                Generation progress
              </h6>
              <span
                className="small"
                style={{
                  color: '#64748b',
                  fontWeight: 500,
                  fontSize: '0.8125rem'
                }}
              >
                {station}
              </span>
            </div>

            <div className="d-flex align-items-center gap-2 small" style={{ fontSize: '0.8125rem' }}>
              {failedSteps > 0 && (
                <span style={{ color: '#dc2626', fontWeight: 500 }}>
                  {failedSteps} failed
                </span>
              )}
              <span style={{ color: '#64748b', fontWeight: 500 }}>
                {completedSteps} / {stepsStatus.length} complete
              </span>
            </div>

            <div className="d-flex align-items-center gap-3">
              <button
                type="button"
                onClick={this.handleDownloadGeneratedZip}
                className={`btn ${isGeneratedZipReady ? 'btn-success' : ''} d-inline-flex align-items-center justify-content-center`}
                disabled={!isGeneratedZipReady || this.props.isDownloadingGeneratedZip}
                style={{
                  minHeight: '34px',
                  borderRadius: '7px',
                  fontWeight: isGeneratedZipReady ? 600 : 550,
                  whiteSpace: 'nowrap',
                  fontSize: '0.8125rem',
                  border: isGeneratedZipReady ? undefined : '1px solid #0a1c32',
                  backgroundColor: isGeneratedZipReady ? undefined : '#ffffff',
                  color: isGeneratedZipReady ? undefined : '#1e3a5f',
                  padding: '0 12px',
                  boxShadow: isGeneratedZipReady ? '0 1px 3px rgba(21, 128, 61, 0.2)' : 'none',
                  transition: 'background-color 0.15s ease, border-color 0.15s ease'
                }}
              >
                {this.props.isDownloadingGeneratedZip ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-label="Downloading ZIP"></span>
                    Preparing ZIP...
                  </>
                ) : (
                  <>
                    <i className="bi bi-file-zip me-2" aria-hidden="true"></i>
                    Download ZIP
                  </>
                )}
              </button>
            </div>
          </div>

          {/* Steps list */}
          <div style={{ padding: '2px 0' }}>
            <div ref={element => { this.stepsContainerRef = element; }}>
              {stepsStatus.map((step, idx) => (
                <div
                  key={idx}
                  data-step-id={step.id}
                  className={`conversion-step-row d-flex align-items-center gap-2 px-3 ${this.state.dragOverStepId === step.id ? 'is-drop-target' : ''} ${this.state.draggingStepId === step.id ? 'is-dragging' : ''}`}
                  draggable={!isAnyLoading && !this.state.generationStarted}
                  onDragStart={(event) => this.handleStepDragStart(event, step.id)}
                  onDragEnd={this.handleStepDragEnd}
                  onDragOver={(event) => this.handleStepDragOver(event, step.id)}
                  onDrop={(event) => this.handleStepDrop(event, step.id)}
                  style={{
                    backgroundColor:
                      step.status === 'loading' ? '#fffbeb' :
                        step.status === 'error' ? '#fef2f2' :
                          step.status === 'completed' ? '#f0fdf4' :
                            'transparent',
                    borderBottom: idx < stepsStatus.length - 1 ? '1px solid #cbd5e1' : 'none',
                    opacity: this.state.draggingStepId === step.id ? 0.4 : 1,
                    cursor: !isAnyLoading && !this.state.generationStarted ? 'grab' : 'default',
                    paddingTop: '8px',
                    paddingBottom: '8px',
                    minHeight: '40px',
                    transition: 'background-color 0.15s ease'
                  }}
                >

                  <div
                    className="row align-items-center justify-content-between w-100"
                    style={{ minHeight: '36px' }}>
                    <div className="col-md-3">
                      <div className="d-flex align-items-center gap-2">
                        <div className="d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '20px', height: '20px' }}>
                          {step.status === 'loading' && (
                            <span className="spinner-border spinner-border-sm" role="status" style={{ color: '#d97706', width: '0.95rem', height: '0.95rem' }}>
                              <span className="visually-hidden">Processing {step.name}</span>
                            </span>
                          )}
                          {step.status === 'completed' && <i className="bi bi-check-circle-fill" style={{ color: '#16a34a', fontSize: '1rem' }}></i>}
                          {step.status === 'error' && <i className="bi bi-exclamation-circle-fill" style={{ color: '#dc2626', fontSize: '1rem' }}></i>}
                          {step.status === 'pending' && <i className="bi bi-circle" style={{ color: '#94a3b8', fontSize: '0.9rem' }}></i>}
                        </div>
                        <span
                          style={{
                            color: step.status === 'error' ? '#b91c1c' : step.status === 'completed' ? '#166534' : '#1e293b',
                            fontWeight: step.status === 'completed' || step.status === 'loading' ? 600 : 500,
                            fontSize: '0.875rem',
                            lineHeight: 1.3,
                            overflowWrap: 'anywhere'
                          }}
                        >
                          {step.name}
                        </span>
                      </div>
                    </div>

                    <div className="col-md-5 d-flex flex-column justify-content-center align-items-center">
                      {this.renderStepProgress(step)}
                      {step.status === 'error' && step.errorMessage && (
                        <div
                          className="mb-0 small"
                          role="alert"
                          style={{
                            width: '100%',
                            overflowWrap: 'anywhere',
                            backgroundColor: '#fef2f2',
                            border: '1px solid #fecaca',
                            borderRadius: '5px',
                            padding: '5px 8px',
                            color: '#991b1b',
                            fontSize: '0.75rem',
                            lineHeight: 1.4,
                            marginTop: '5px'
                          }}
                        >
                          {step.errorMessage}
                        </div>
                      )}
                    </div>

                    <div className="col-md-4 d-flex justify-content-end align-items-center flex-shrink-0">
                      {this.renderStepActions(step)}
                    </div>
                  </div>

                </div>
              ))}
            </div>

            {/* Overall progress footer */}
            <div
              style={{
                padding: '10px 14px 12px',
                borderTop: '1px solid #cbd5e1',
                backgroundColor: '#fafbfc'
              }}
            >
              <div className="d-flex justify-content-between align-items-center gap-2 mb-1">
                <span
                  style={{
                    fontSize: '0.6875rem',
                    fontWeight: 600,
                    color: '#64748b',
                    textTransform: 'uppercase',
                    letterSpacing: '0.03em'
                  }}
                >
                  Overall
                </span>
                <span
                  style={{
                    fontSize: '0.75rem',
                    fontWeight: 500,
                    color: failedSteps ? '#dc2626' : progressPercent === 100 ? '#16a34a' : '#64748b'
                  }}
                >
                  {failedSteps ? 'Some files need attention' : progressPercent === 100 ? 'All files generated' : 'Ready to start'}
                </span>
              </div>
              <div
                className="progress"
                style={{ height: '5px', borderRadius: '999px', backgroundColor: '#e2e8f0' }}
              >
                <div
                  className="progress-bar"
                  style={{
                    width: `${progressPercent}%`,
                    transition: 'width 0.3s ease',
                    backgroundColor: failedSteps ? '#ef4444' : '#22c55e',
                    borderRadius: '999px'
                  }}
                  role="progressbar"
                  aria-valuenow={progressPercent}
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div>
          </div>
        </section>

        {/* CUSTOMIZATION MODAL (ONLY FOR SER ZONE) */}
        {showOptionsModal && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(15, 23, 42, 0.45)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              zIndex: 1050,
              backdropFilter: 'blur(2px)'
            }}
          >
            <div
              className="bg-white"
              style={{
                maxWidth: '560px',
                width: '92%',
                borderRadius: '12px',
                boxShadow: '0 20px 40px rgba(15, 23, 42, 0.18), 0 0 0 1px rgba(15, 23, 42, 0.04)',
                overflow: 'hidden'
              }}
            >
              {/* Modal header */}
              <div
                className="d-flex justify-content-between align-items-center px-4 py-3"
                style={{ borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}
              >
                <h5
                  className="mb-0"
                  style={{
                    fontWeight: 600,
                    fontSize: '1.05rem',
                    color: '#0f172a',
                    letterSpacing: '-0.01em'
                  }}
                >
                  SER Generation Options
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={this.handleCloseOptionsModal}
                  style={{ fontSize: '0.75rem' }}
                ></button>
              </div>

              <div className="px-4 pt-3 pb-2">
                {/* Navigation Tabs */}
                <ul
                  className="nav nav-tabs mb-3"
                  style={{ borderBottom: '1px solid #e2e8f0' }}
                >
                  <li className="nav-item">
                    <button
                      className="nav-link disabled"
                      disabled
                      style={{
                        color: '#94a3b8',
                        fontSize: '0.8125rem',
                        fontWeight: 500,
                        border: 'none',
                        padding: '8px 12px'
                      }}
                    >
                      TD Excel
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className="nav-link disabled"
                      disabled
                      style={{
                        color: '#94a3b8',
                        fontSize: '0.8125rem',
                        fontWeight: 500,
                        border: 'none',
                        padding: '8px 12px'
                      }}
                    >
                      TD PDF
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className="nav-link disabled"
                      disabled
                      style={{
                        color: '#94a3b8',
                        fontSize: '0.8125rem',
                        fontWeight: 500,
                        border: 'none',
                        padding: '8px 12px'
                      }}
                    >
                      RFID Layout
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${activeTab === 'toc' ? 'active' : ''}`}
                      onClick={() => this.setState({ activeTab: 'toc' })}
                      style={{
                        color: activeTab === 'toc' ? '#1e3a5f' : '#64748b',
                        fontWeight: activeTab === 'toc' ? 600 : 500,
                        fontSize: '0.8125rem',
                        border: 'none',
                        borderBottom: activeTab === 'toc' ? '2px solid #1e3a5f' : '2px solid transparent',
                        padding: '8px 12px',
                        backgroundColor: 'transparent',
                        borderRadius: 0
                      }}
                    >
                      TOC Options
                    </button>
                  </li>
                </ul>

                {/* Tab Contents */}
                <div className="tab-content py-2">
                  {activeTab === 'toc' && (
                    <div>
                      <div className="mb-3">
                        <label
                          className="form-label"
                          style={{
                            fontWeight: 600,
                            fontSize: '0.8125rem',
                            color: '#334155',
                            marginBottom: '6px'
                          }}
                        >
                          Select First Signature
                        </label>
                        <DropDownListS
                          selectedValue={serFirstSignature}
                          data={this.signatureOptions}
                          onUpdateSelectedValue={(val) => this.setState({
                            serFirstSignature: val,
                            serSignatureDefaultsSaved: false
                          })}
                          placeholder="Select First Signature"
                        />
                      </div>

                      <div className="mb-2">
                        <label
                          className="form-label"
                          style={{
                            fontWeight: 600,
                            fontSize: '0.8125rem',
                            color: '#334155',
                            marginBottom: '6px'
                          }}
                        >
                          Select Second Signature
                        </label>
                        <DropDownListS
                          selectedValue={serSecondSignature}
                          data={this.signatureOptions}
                          onUpdateSelectedValue={(val) => this.setState({
                            serSecondSignature: val,
                            serSignatureDefaultsSaved: false
                          })}
                          placeholder="Select Second Signature"
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal footer */}
              <div
                className="d-flex justify-content-end gap-2 px-4 py-3"
                style={{ borderTop: '1px solid #e2e8f0', backgroundColor: '#f8fafc' }}
              >
                <button
                  className="btn"
                  onClick={this.saveSerSignatureDefaults}
                  style={{
                    minHeight: '38px',
                    padding: '0 16px',
                    marginRight: 'auto',
                    borderRadius: '7px',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    border: '1px solid #cbd5e1',
                    backgroundColor: '#ffffff',
                    color: '#1e3a5f'
                  }}
                >
                  {this.state.serSignatureDefaultsSaved ? 'Defaults saved' : 'Save as my defaults'}
                </button>
                <button
                  className="btn"
                  onClick={this.handleCloseOptionsModal}
                  style={{
                    minHeight: '38px',
                    padding: '0 16px',
                    borderRadius: '7px',
                    fontWeight: 500,
                    fontSize: '0.875rem',
                    border: '1px solid #cbd5e1',
                    backgroundColor: '#ffffff',
                    color: '#475569'
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn"
                  onClick={this.handleStartBulkConversion}
                  disabled={!isGenerationVersionReady || isAnyLoading}
                  style={{
                    minHeight: '38px',
                    padding: '0 18px',
                    borderRadius: '7px',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    backgroundColor: '#1e3a5f',
                    borderColor: '#1e3a5f',
                    color: '#ffffff',
                    boxShadow: '0 1px 2px rgba(30, 58, 95, 0.2)'
                  }}
                >
                  Generate Documents
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Success modal temporarily disabled.
        {(success || imageSuccess) && (
          <div style={{
            position: 'fixed',
            top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000
          }}>
            <div className="p-4 bg-white rounded text-center" style={{ maxWidth: '500px', width: '90%' }}>
              <img src="/success_icon.png" alt="Success" style={{ width: '50px', marginBottom: '15px' }} />
              <div style={{ fontSize: 'clamp(1rem, 2vw, 1.1rem)', marginBottom: '20px', fontWeight: '500' }}>
                {success && (error
                  ? 'Generation completed with some errors'
                  : 'Documents generated successfully')}
                {imageSuccess && 'RFID Image PDF Successfully Generated'}
              </div>

              <button onClick={this.handleDismissPopup} className="btn btn-dark px-4 me-4">
                Close &nbsp; ✕
              </button>

              <button onClick={this.handleClosePopup} className="btn btn-dark px-4">
                Done
              </button>
            </div>
          </div>
        )}
        */}

        {error && (
          <div
            className="mt-3"
            role="alert"
            style={{
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '8px',
              padding: '12px 14px',
              color: '#991b1b',
              fontSize: '0.875rem',
              fontWeight: 500
            }}
          >
            {error}
          </div>
        )}
        {imageError && (
          <div
            className="mt-3"
            role="alert"
            style={{
              backgroundColor: '#fef2f2',
              border: '1px solid #fecaca',
              borderRadius: '8px',
              padding: '12px 14px',
              color: '#991b1b',
              fontSize: '0.875rem',
              fontWeight: 500
            }}
          >
            {imageError}
          </div>
        )}
      </div>
    );
  }
}

export default StepThree;